// import React, {useEffect, useState} from 'react';
// import moment from "moment";

// const TimeCounter = ({initialMilliseconds}) => {
//     const [elapsedTime, setElapsedTime] = useState(initialMilliseconds || 0);


//     useEffect(()=>{
//         setElapsedTime(initialMilliseconds)
//     },[initialMilliseconds])

//     useEffect(() => {
//         const intervalId = setInterval(() => {
//             setElapsedTime((prevElapsedTime) => prevElapsedTime + 1000);
//         }, 1000);

//         return () => {
//             clearInterval(intervalId);
//         };
//     }, []);

//     function formatTime(ms) {
//         const duration = moment.duration(ms);
//         const hours = duration.hours();
//         const minutes = duration.minutes();
//         const seconds = duration.seconds();

//         const formattedHours = hours < 10 ? '0' + hours : hours;
//         const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
//         const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

//         return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
//     }

//     return (
//         <div>
//             <div>{formatTime(elapsedTime)}</div>
//         </div>
//     );
// };

// export default TimeCounter;
import React, { useEffect, useState, useRef } from 'react';
import moment from "moment";

const TimeCounter = ({ initialMilliseconds, staffId }) => {
    const [elapsedTime, setElapsedTime] = useState(0);
    const intervalRef = useRef(null);
    const storageKey = `timerState_${staffId}`;
    const isMountedRef = useRef(true);
    const startTimeRef = useRef(null);
    const baseTimeRef = useRef(0);

    // Initialize timer
    useEffect(() => {
        isMountedRef.current = true;

        const loadState = () => {
            try {
                const saved = localStorage.getItem(storageKey);
                if (saved) {
                    const { baseTime, savedAt } = JSON.parse(saved);
                    return {
                        baseTime,
                        startTime: Date.now(), // Current time as new start time
                        initialElapsed: baseTime
                    };
                }
            } catch (e) {
                console.error("Failed to load timer state", e);
            }

            const now = Date.now();
            return {
                baseTime: initialMilliseconds || 0,
                startTime: now,
                initialElapsed: initialMilliseconds || 0
            };
        };

        const { baseTime, startTime, initialElapsed } = loadState();
        baseTimeRef.current = baseTime;
        startTimeRef.current = startTime;
        setElapsedTime(initialElapsed);

        // Timer function
        const updateTimer = () => {
            if (!isMountedRef.current) return;

            const now = Date.now();
            const newElapsed = baseTimeRef.current + (now - startTimeRef.current);
            setElapsedTime(newElapsed);

            // Save state every second
            localStorage.setItem(storageKey, JSON.stringify({
                baseTime: newElapsed,
                savedAt: now
            }));
        };

        // Start with immediate update then every second
        updateTimer();
        intervalRef.current = setInterval(updateTimer, 1000);

        return () => {
            isMountedRef.current = false;
            clearInterval(intervalRef.current);

            // Final save
            const now = Date.now();
            const finalTime = baseTimeRef.current + (now - startTimeRef.current);
            localStorage.setItem(storageKey, JSON.stringify({
                baseTime: finalTime,
                savedAt: now
            }));
        };
    }, [initialMilliseconds, staffId]);

    // Remove this cleanup effect completely - it was causing the issue
    // useEffect(() => {
    //     return () => {
    //         setTimeout(() => {
    //             if (!document.querySelectorAll(`[data-staff-id="${staffId}"]`).length) {
    //                 localStorage.removeItem(storageKey);
    //             }
    //         }, 100);
    //     };
    // }, [staffId]);

    const formatTime = (ms) => {
        const duration = moment.duration(ms);
        const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
        const minutes = duration.minutes().toString().padStart(2, '0');
        const seconds = duration.seconds().toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    return (
        <div data-staff-id={staffId}>
            <div>{formatTime(elapsedTime)}</div>
        </div>
    );
};

export default TimeCounter;